<template>
  <div class="three-d-view">
    <div class="threedcontainer" ref="threedcontainer">
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'threeDView',
  data () {
    return {
      PJModel: [],
      isDraggingPj: false,
      ratio: 100,
      wallThickness: 0.2,
      roomWInit: 500,
      roomHInit: 350,
      roomDInit: 1000,
      outOfRange: false,
      newVector: new THREE.Vector3(),
      wallOffset: 0.01,
      publicPath: process.env.BASE_URL,
      pjType0DesktopR: {
        x: 0,
        y: Math.PI / 2,
        z: 0
      },
      pjType1DesktopR: {
        x: 0,
        y: 0,
        z: 0
      },
      pjType2DesktopR: {
        x: 0,
        y: Math.PI,
        z: 0
      },
      pjType0CeilingR: {
        x: 0,
        y: -Math.PI / 2,
        z: Math.PI
      },
      pjType1CeilingR: {
        x: 0,
        y: 0,
        z: Math.PI
      },
      pjType2CeilingR: {
        x: 0,
        y: Math.PI,
        z: Math.PI
      },
      PJModelGroup: '',
      linePointArr: [],
      topLineP: [],
      helpLineP: [],
      edgePoints: [],
      dashDatas: [],
      avaiRange: [],
      lensShiftScreenP: [],
      lensShiftRangeP: []
    }
  },
  methods: {
    ...mapMutations([
      'PJX',
      'PJY',
      'PJZ',
      'SCRNW',
      'SCRNH',
      'SCREENSIZE',
      'SET_DRAWDATA',
      'SET_BLACKDRAWDATA',
      'SET_RANGEDRAWDATA',
      'SET_CENTERPOINTDATA',
      'SET_VLENSSHIFT',
      'SET_TEMVLENSSHIFT',
      'SET_HLENSSHIFT',
      'SET_INITSCREENSIZEW',
      'SET_INITSCREENSIZEH',
      'SET_DASHDATA',
      'SET_DASHDATAREMAIN',
      'SET_ISTOUCH',
      'SET_SCREEN4POINT',
      'SET_FLTOB',
      'SET_FLTOL',
      'SET_SCREENSIZE',
      'SET_GRAPH_ROOMD'
    ]),
    init () {
      this.roomWInit = this.houseInfo.roomW ? this.houseInfo.roomW : this.roomWInit
      this.roomHInit = this.houseInfo.roomH ? this.houseInfo.roomH : this.roomHInit
      this.roomDInit = this.houseInfo.roomD ? this.houseInfo.roomD : this.roomDInit
      this.container = this.$refs.threedcontainer
      this.innerWidth = this.container.offsetWidth
      this.innerHeight = this.container.offsetHeight
      this.scene = new THREE.Scene()
      this.camera = new THREE.PerspectiveCamera(50, this.innerWidth / this.innerHeight, 0.01, 1000)
      this.camera.position.set(-8, 1, 12)
      this.addToScene(this.camera)

      this.renderer = new THREE.WebGLRenderer({
        antialias: true
      })
      this.renderer.setSize(this.innerWidth, this.innerHeight)
      this.renderer.setClearColor(0xFFFFFF)
      this.renderer.clear()
      this.container.appendChild(this.renderer.domElement)
      this.OrbitControls = new OrbitControls(this.camera, this.renderer.domElement)
      this.OrbitControls.enableKeys = false
      // this.OrbitControls.enableZoom = false
      // this.OrbitControls.enablePan = false
      this.createScene()
      window.addEventListener('resize', this.onWindowResize, false)
    },
    setPJModelAttibuteAndAddToScene (status) {
      this.findCurrentPJModelByType()
      this.setPJModelAttibute()
      // this.addTransformControl()
      this.addToScene(this.PJModelGroup)
      this.PJModelGroup.visible = true
    },
    addToScene (item) {
      if (!this.isUSTWall) {
        this.scene.add(item)
      }
    },
    findCurrentPJModelByType () {
      let pjModel = null
      if (this.projectorImgType === 0) {
        pjModel = this.PJModelGroupType0
      } else if (this.projectorImgType === 1) {
        pjModel = this.PJModelGroupType1
      } else {
        pjModel = this.PJModelGroupType2
      }
      this.PJModelGroup = pjModel
    },
    setPJModelAttibute () {
      let pointA = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      this.PJModelGroup.position.set(pointA.x, pointA.y, pointA.z)
      this.setPJModelScale()
      this.setPJModelRotation()
    },
    setPJModelScale () {
      if (this.projectorImgType === 0) {
        this.PJModelGroup.scale.set(0.2, 0.2, 0.2)
      } else if (this.projectorImgType === 1) {
        this.PJModelGroup.scale.set(0.2, 0.2, 0.2)
      } else {
        this.PJModelGroup.scale.set(0.15, 0.15, 0.15)
      }
    },
    setPJModelRotation () {
      let val = this.getPJModelInitRotation()
      this.PJModelGroup.rotation.set(val.x, val.y, val.z)
      if (this.hAngleFlag) {
        this.setPjModelhAngle(this.hAngle, val)
      } else {
        this.setPjModelhAngle(0, val)
      }
      if (this.vAngleFlag) {
        this.setPjModelvAngle(this.vAngle)
      } else {
        this.setPjModelvAngle(0)
      }
    },
    getPJModelInitRotation () {
      let val = {}
      switch (this.projectorImgType) {
        case 0:
          if (this.position !== 1) {
            val = this.pjType0DesktopR
          } else {
            val = this.pjType0CeilingR
          }
          break
        case 1:
          if (this.position !== 1) {
            val = this.pjType1DesktopR
          } else {
            val = this.pjType1CeilingR
          }
          break
        case 2:
          if (this.position !== 1) {
            val = this.pjType2DesktopR
          } else {
            val = this.pjType2CeilingR
          }
          break
        default:
          break
      }
      return val
    },
    addTransformControl () {
      if (!this.transformCtrl) {
        this.transformCtrl = new TransformControls(this.camera, this.renderer.domElement)
      }
      if (this.PJModelGroup) {
        this.transformCtrl.attach(this.PJModelGroup)
        this.transformCtrl.addEventListener('dragging-changed', function (event) {
          this.OrbitControls.enabled = !event.value
        }.bind(this))
        this.transformCtrl.addEventListener('mouseDown', this.onTransformMouseDown)
        this.transformCtrl.addEventListener('objectChange', this.OnProjectorDrag)
        document.addEventListener('mouseup', this.onTransformMouseUp)
        this.addToScene(this.transformCtrl)
      }
    },
    onWindowResize () {
      this.innerWidth = this.container.offsetWidth
      this.innerHeight = this.container.offsetHeight
      this.camera.aspect = this.innerWidth / this.innerHeight
      this.camera.updateProjectionMatrix()

      this.renderer.setSize(this.innerWidth, this.innerHeight)
    },
    createScene () {
      this.createRoomGeometry()
      this.createLight()
      this.setLines(true)
      this.initFlatColor()
      this.animate()
    },
    createRoomGeometry () {
      let point = this.getRoomCubePoint()
      let loader = new THREE.TextureLoader()
      let width = this.roomWInit / 100
      let depth = this.roomDInit / 100
      let height = this.roomHInit / 100
      let wallImg = loader.load(require('@/assets/parts/graph/wall.png'))
      let bigWallImg = loader.load(require('@/assets/parts/graph/bigWall.png'))
      let material = new THREE.MeshBasicMaterial({ map: wallImg, opacity: 0.7, side: THREE.DoubleSide, transparent: true }, this.animate())
      let curtainMtl = new THREE.MeshBasicMaterial({ map: wallImg, side: THREE.DoubleSide, transparent: true }, this.animate())
      let bigWallMtl = new THREE.MeshBasicMaterial({ map: bigWallImg, opacity: 0.1, side: THREE.DoubleSide, transparent: true }, this.animate())
      let leftMaterial = new THREE.MeshBasicMaterial({ map: wallImg, opacity: 0.7, side: THREE.BackSide, transparent: true }, this.animate())

      let frontWallGeo = new THREE.BoxBufferGeometry(width, height, this.wallThickness)
      let frontWallImgGeo = new THREE.PlaneGeometry(width, height)
      let frontBigWallImgGeo = new THREE.PlaneGeometry(100, 100)
      this.frontWall = this.createWall(frontWallGeo)
      this.frontWallImg = new THREE.Mesh(frontWallImgGeo, material)
      this.curtainImg = new THREE.Mesh(frontWallImgGeo, curtainMtl)
      this.frontBigWallImg = new THREE.Mesh(frontBigWallImgGeo, bigWallMtl)
      this.frontBigWallImg.renderOrder = 1
      this.frontWallImg.renderOrder = 5

      let rightWallGeo = new THREE.BoxBufferGeometry(depth, height, this.wallThickness)
      let rightWallImgGeo = new THREE.PlaneBufferGeometry(depth, height)
      this.rightWall = this.createWall(rightWallGeo)
      this.rightWallImg = new THREE.Mesh(rightWallImgGeo, material)
      this.rightWall.rotation.y = -Math.PI / 2
      this.rightWallImg.rotation.y = -Math.PI / 2

      let leftWallImgGeo = new THREE.PlaneBufferGeometry(depth, height)
      this.leftWallImg = new THREE.Mesh(leftWallImgGeo, leftMaterial)
      this.leftWallImg.rotation.y = -Math.PI / 2

      this.createFloor(point)
      this.createRoof(point)

      this.setRoomGeometryPosition(point)
      // this.addToScene(this.frontBigWallImg)
      this.addToScene(this.frontWall)
      // this.addToScene(this.frontWallImg)
      // this.addToScene(this.curtainImg)
      this.addToScene(this.rightWall)
      // this.addToScene(this.rightWallImg)

      // this.addToScene(this.leftWallImg)
      this.addToScene(this.floor)
      // this.addToScene(this.roof)
    },
    createWall (geometry) {
      let wallMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.5 })
      let wallEdgesMtl = new THREE.LineBasicMaterial({ color: 0xff666666, linewidth: 1 })

      let wall = new THREE.Mesh(geometry, wallMaterial)
      let wallEdges = new THREE.EdgesGeometry(geometry)
      let wallLine = new THREE.LineSegments(wallEdges, wallEdgesMtl)
      let wallGroup = new THREE.Group()

      wallGroup.add(wall)
      wallGroup.add(wallLine)
      return wallGroup
    },
    createFloor (point) {
      let width = this.roomWInit / 100
      let depth = this.roomDInit / 100
      let loader = new THREE.TextureLoader()
      let floorImg = loader.load(require('@/assets/parts/graph/floor.png'))

      let geometry = new THREE.PlaneBufferGeometry(width, depth)
      let material = new THREE.MeshBasicMaterial({ map: floorImg, opacity: 0.7, side: THREE.DoubleSide, transparent: true }, this.animate())
      this.floor = new THREE.Mesh(geometry, material)
      this.floor.rotation.x = -Math.PI / 2
    },
    createRoof (point) {
      let width = this.roomWInit / 100
      let depth = this.roomDInit / 100
      let loader = new THREE.TextureLoader()
      let floorImg = loader.load(require('@/assets/parts/graph/floor.png'))

      let geometry = new THREE.PlaneBufferGeometry(width, depth)
      let material = new THREE.MeshBasicMaterial({ map: floorImg, opacity: 0.7, side: THREE.BackSide, transparent: true }, this.animate())
      this.roof = new THREE.Mesh(geometry, material)
      this.roof.rotation.x = -Math.PI / 2
    },
    setRoomGeometryPosition (point) {
      this.frontWall.position.setZ(point.b2.z - this.wallThickness / 2 - this.wallOffset)
      this.frontWallImg.position.setZ(point.b2.z)
      this.curtainImg.position.setZ(point.b2.z + this.offsetVal)
      this.frontBigWallImg.position.setZ(point.b2.z + this.offsetVal)
      this.rightWall.position.setX(point.threeD3.x + this.wallThickness / 2 + this.wallOffset)
      this.rightWallImg.position.setX(point.threeD3.x)
      this.leftWallImg.position.setX(-point.threeD3.x)
      this.floor.position.setY(point.c3.y)
      this.roof.position.setY(-point.c3.y)
    },

    createLight () {
      let ambientLight = new THREE.AmbientLight(0x404040)
      this.addToScene(ambientLight)

      let pointLight = new THREE.PointLight(0xffffff)
      pointLight.position.set(-10, 5, 10)
      this.addToScene(pointLight)
    },
    setLines (status) {
      this.helpLineP = []
      this.removeLines()
      this.updateObjectMatrix()
      // this.setCenterLine()
      this.clearPoints()
      this.createLensShiftP()
      this.setBlackArea()
      this.setEdgeLines()
      this.setDashLines()
      if (!status) {
        this.updateFlatColor()
      }
    },
    clearPoints () {
      this.frontFlatP = []
      this.leftFlatP = []
      this.rightFlatP = []
      this.topFlatP = []
      this.bottomFlatP = []
      this.allPoints = []
      this.lensShiftRangeP = []
      this.lensShiftScreenP = []
    },
    createLensShiftP () {
      let lightCenter = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      let rayOrigin = this.createRay(this.selectedLensData.lcd.aspectRatio)
      // 为lensShiftRangeP赋值
      this.setAvailabelRange(rayOrigin, 'lensShiftRangeP')

      let rayLensShift = this.setRayLensShfit(rayOrigin)

      let leftTopRaycaster = new THREE.Raycaster(lightCenter, rayLensShift.LTRay)
      this.lensShiftScreenP.push(this.getBigWallIntersectPoint(leftTopRaycaster))

      let rightTopRaycaster = new THREE.Raycaster(lightCenter, rayLensShift.RTRay)
      this.lensShiftScreenP.push(this.getBigWallIntersectPoint(rightTopRaycaster))

      let rightBottomRaycaster = new THREE.Raycaster(lightCenter, rayLensShift.RBRay)
      this.lensShiftScreenP.push(this.getBigWallIntersectPoint(rightBottomRaycaster))

      let leftBottomRaycaster = new THREE.Raycaster(lightCenter, rayLensShift.LBRay)
      this.lensShiftScreenP.push(this.getBigWallIntersectPoint(leftBottomRaycaster))
      this.checkLensShiftStatus()
    },
    checkLensShiftStatus () {
      let isTouch = false
      let screenP = []
      let rangeP = []
      if (this.lensShiftRangeP.length !== 8 || this.lensShiftScreenP.length !== 4) {
        return
      }
      for (let n = 0; n < this.lensShiftRangeP.length; n++) {
        let val = {}
        val.x = this.transTwoViewP(this.lensShiftRangeP[n]).x
        val.y = this.transTwoViewP(this.lensShiftRangeP[n]).z
        rangeP.push(val)
      }
      for (let j = 0; j < this.lensShiftScreenP.length; j++) {
        let point = {}
        point.x = this.transTwoViewP(this.lensShiftScreenP[j]).x
        point.z = this.transTwoViewP(this.lensShiftScreenP[j]).z
        screenP.push(point)
      }

      for (let i = 0; i < screenP.length; i++) {
        let p = {}
        if (i === 0) {
          p.x = screenP[i].x + this.limitData
          p.y = screenP[i].z + this.limitData
        } else if (i === 1) {
          p.x = screenP[i].x - this.limitData
          p.y = screenP[i].z + this.limitData
        } else if (i === 2) {
          p.x = screenP[i].x - this.limitData
          p.y = screenP[i].z - this.limitData
        } else if (i === 3) {
          p.x = screenP[i].x + this.limitData
          p.y = screenP[i].z - this.limitData
        }
        if (this.$commonJs.rayCasting(p, rangeP) === 'out') {
          isTouch = true
          break
        }
      }
      this.SET_ISTOUCH(isTouch)
    },
    setCenterLine () {
      let lightCenter = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      let centerPDirect = new THREE.Vector3(0, 0, -1)
      if (this.vLensShiftNow) {
        let vData = (this.baseLTRay.y - this.baseLBRay.y) * this.vLensShiftNow / 100
        centerPDirect.y += vData
      }
      if (this.hLensShiftNow) {
        let hData = (this.baseRTRay.x - this.baseLTRay.x) * this.hLensShiftNow / 100
        centerPDirect.x += hData
      }
      let centerRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(centerPDirect))
      this.centerCrossingP = this.getIntersectPoint(centerRaycaster)
      this.createCenterLine(lightCenter, this.centerCrossingP.value)
      this.centerLine.renderOrder = 50
      let twoDCenterP = this.transTwoViewP(this.centerCrossingP.value)
      this.SET_CENTERPOINTDATA(twoDCenterP)
    },
    setEdgeLines () {
      let lightCenter = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      // lightCenter.setZ(lightCenter.z + this.offsetVal)
      let rayOrigin = this.createRay(this.aspectRatio, true)
      let rayLensShift = this.setRayLensShfit(rayOrigin, true)

      this.edgePoints = []
      let leftTopRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.LTRay))
      this.leftTopP = this.getIntersectPoint(leftTopRaycaster).value
      this.leftTopLine = this.createEdgeLine(lightCenter, this.leftTopP)

      let rightTopRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.RTRay))
      this.rightTopP = this.getIntersectPoint(rightTopRaycaster).value
      this.rightTopLine = this.createEdgeLine(lightCenter, this.rightTopP)

      let rightBottomRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.RBRay))
      this.rightBottomP = this.getIntersectPoint(rightBottomRaycaster).value
      this.rightBottomLine = this.createEdgeLine(lightCenter, this.rightBottomP)

      let leftBottomRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.LBRay))
      this.leftBottomP = this.getIntersectPoint(leftBottomRaycaster).value
      this.leftBottomLine = this.createEdgeLine(lightCenter, this.leftBottomP)
      // this.leftTopLine.material.depthTest = false
      this.leftTopLine.renderOrder = 100
      this.rightTopLine.renderOrder = 100
      this.rightBottomLine.renderOrder = 100
      this.leftBottomLine.renderOrder = 100
      this.edgePoints.push(this.leftTopP)
      this.edgePoints.push(this.rightTopP)
      this.edgePoints.push(this.rightBottomP)
      this.edgePoints.push(this.leftBottomP)
      this.setHelpLines(rayLensShift, true)
    },
    setBlackArea () {
      let lightCenter = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      // lightCenter.setZ(lightCenter.z + this.offsetVal)
      let rayOrigin = this.createRay(this.selectedLensData.lcd.aspectRatio)
      this.setAvailabelRange(rayOrigin)

      let rayLensShift = this.setRayLensShfit(rayOrigin)
      this.checkIsAvaInter(rayLensShift)

      this.blackEdgePoints = []
      let leftTopRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.LTRay))
      this.blackLeftTopP = this.getIntersectPoint(leftTopRaycaster).value

      let rightTopRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.RTRay))
      this.blackRightTopP = this.getIntersectPoint(rightTopRaycaster).value

      let rightBottomRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.RBRay))
      this.blackRightBottomP = this.getIntersectPoint(rightBottomRaycaster).value

      let leftBottomRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.LBRay))
      this.blackLeftBottomP = this.getIntersectPoint(leftBottomRaycaster).value
      this.blackEdgePoints.push(this.blackLeftTopP)
      this.blackEdgePoints.push(this.blackRightTopP)
      this.blackEdgePoints.push(this.blackRightBottomP)
      this.blackEdgePoints.push(this.blackLeftBottomP)

      this.setHelpLines(rayLensShift)
    },
    setAvailabelRange (value, status) {
      let LTRay = value.LTRay
      let RTRay = value.RTRay
      let RBRay = value.RBRay
      let LBRay = value.LBRay
      let availP = []
      let val = 0
      let vlensMax = this.vLensShiftMax
      let vlensMin = this.vLensShiftMin

      let vMax = (this.baseLTRay.y - this.baseLBRay.y) * vlensMax
      let point1 = JSON.parse(JSON.stringify(LTRay))
      let point2 = JSON.parse(JSON.stringify(RTRay))
      point1.y += vMax
      point2.y += vMax

      let vMin = (this.baseLTRay.y - this.baseLBRay.y) * vlensMin
      let point5 = JSON.parse(JSON.stringify(RBRay))
      let point6 = JSON.parse(JSON.stringify(LBRay))
      point5.y += vMin
      point6.y += vMin

      if (vlensMin > 0) {
        val = vlensMin
      }
      if (vlensMax < 0) {
        val = vlensMax
      }
      let vhMax = (this.baseLTRay.y - this.baseLBRay.y) * (this.vhLensShiftMax + val)
      let point8 = JSON.parse(JSON.stringify(LTRay))
      let point3 = JSON.parse(JSON.stringify(RTRay))
      point8.y += vhMax
      point3.y += vhMax

      let vhMin = (this.baseLTRay.y - this.baseLBRay.y) * (this.vhLensShiftMin + val)
      let point4 = JSON.parse(JSON.stringify(RBRay))
      let point7 = JSON.parse(JSON.stringify(LBRay))
      point7.y += vhMin
      point4.y += vhMin

      let hMax = (this.baseRTRay.x - this.baseLTRay.x) * this.hLensShiftMax
      point4.x += hMax
      point3.x += hMax

      let hMin = (this.baseRTRay.x - this.baseLTRay.x) * this.hLensShiftMin
      point7.x += hMin
      point8.x += hMin

      availP.push(point1)
      availP.push(point2)
      availP.push(point3)
      availP.push(point4)
      availP.push(point5)
      availP.push(point6)
      availP.push(point7)
      availP.push(point8)
      if (status) {
        this.getLensShiftRangeP(availP)
      } else {
        this.createAvailableRange(availP, 0)
      }
    },

    checkIsAvaInter (value) {
      let ps = []
      ps.push(JSON.parse(JSON.stringify(value.LTRay)))
      ps.push(JSON.parse(JSON.stringify(value.RTRay)))
      ps.push(JSON.parse(JSON.stringify(value.RBRay)))
      ps.push(JSON.parse(JSON.stringify(value.LBRay)))
      this.createAvailableRange(ps, 1)
    },
    getLensShiftRangeP (value) {
      let lightCenter = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      for (let i = 0; i < value.length; i++) {
        let ray = new THREE.Raycaster(lightCenter, value[i])
        let point = this.getBigWallIntersectPoint(ray)
        if (point) {
          this.lensShiftRangeP.push(point)
        }
      }
    },
    createAvailableRange (value, flag) {
      let lightCenter = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      let availRangeGeo = new THREE.Geometry()
      let availP = []
      let twoViewAvailP = []

      if (value) {
        for (let i = 0; i < value.length; i++) {
          let ray = new THREE.Raycaster(lightCenter, this.setRayAngle(value[i]))
          let point = this.getBigWallIntersectPoint(ray)
          if (point) {
            availP.push(point)
            availRangeGeo.vertices.push(point)
            twoViewAvailP.push(this.transTwoViewP(point))
          }
        }

        availRangeGeo.vertices.push(availP[0])
        if (flag === 0) {
          // 0表示的是获取可移动区域的值的坐标
          this.avaiRange = twoViewAvailP
          this.SET_RANGEDRAWDATA(twoViewAvailP)
          // this.availableLine = this.createAvailableRangeLine(availRangeGeo)
        } else if (flag === 1) {
          this.SET_SCREEN4POINT(twoViewAvailP)
          // 勿删 锁定屏幕的左下角的点坐标，屏幕不移动
          // if (this.throw_distance_checked) {
          //   this.SET_FLTOB(this.houseInfo.roomH - this.screen4Point[3].z)
          //   this.SET_FLTOL(this.screen4Point[3].x)
          // }
        }
      }
    },
    moveScreen (twoViewAvailP, points, i) {
      let p = {}
      p.x = twoViewAvailP[i].x
      p.y = twoViewAvailP[i].z
      let line = []
      if (i === 0) {
        line.push(points[0])
        line.push(points[7])
        this.getPointOnLine(p, line)
      }
    },
    getPointOnLine (p, line) {
      if (window.direction === 'X') {
        let my = line[0].y - (line[0].x - p.x) / ((line[0].x - line[1].x) / (line[0].y - line[1].y))
        let vAngleMove = this.initScreenSize.h * this.vLensShiftNow / 100
        this.SET_VLENSSHIFT((vAngleMove - (my - p.y)) / this.initScreenSize.h * 100)
      } else {
        let mx = line[0].x - (line[0].x - line[1].x) / (line[0].y - line[1].y) * (line[0].y - p.y) + this.limitData
        let hAngleMove = this.initScreenSize.w * this.hLensShiftNow / 100
        this.SET_HLENSSHIFT((hAngleMove + (mx - p.x)) / this.initScreenSize.w * 100)
      }
    },
    createRay (ratioValue, status) {
      let ratio = ratioValue.split(':')
      let ratioW = ratio[0]
      let ratioH = ratio[1]
      let Angle
      if (status) {
        Angle = this.$commonViewJs.getVerAngle(this.graph.pjY)
      } else {
        Angle = this.$commonViewJs.getInitVerAngle(this.graph.pjY)
      }
      let halfAngel = Angle / 2
      let baseX = Math.tan(halfAngel * Math.PI / 180)
      let baseY = baseX * ratioH / ratioW
      let baseZ = -1

      let LTRay = new THREE.Vector3(-baseX, baseY, baseZ)
      let RTRay = new THREE.Vector3(baseX, baseY, baseZ)
      let RBRay = new THREE.Vector3(baseX, -baseY, baseZ)
      let LBRay = new THREE.Vector3(-baseX, -baseY, baseZ)
      if (!status) {
        this.baseLTRay = LTRay
        this.baseRTRay = RTRay
        this.baseRBRay = RBRay
        this.baseLBRay = LBRay
      }
      return { 'LTRay': LTRay, 'RTRay': RTRay, 'RBRay': RBRay, 'LBRay': LBRay }
    },
    setRayLensShfit (value, state) {
      // add lensshift
      let LTRay = value.LTRay
      let RTRay = value.RTRay
      let RBRay = value.RBRay
      let LBRay = value.LBRay

      let vVal = this.vLensShiftNow

      if ((this.selectedModelData.category === this.$constant.PROJECTSPEC_CATEGORY_UST || (this.selectedModelData.category === this.$constant.PROJECTSPEC_CATEGORY_HOME && this.selectedModelData.type === this.$constant.PROJECTSPEC_TYPE_UST)) && !this.screenSizeChecked && !this.throwDistanceChecked) {
        let flag = 1
        if (this.position !== 0) {
          flag = -1
        }
        let distInfo = this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData)

        // let v1a = this.screenSize * distInfo.v1b.w.a
        // let res = (this.graph.scrnH / 2 + v1a) / this.initScreenSize.h
        let v1b = this.screenSize * distInfo.v1b.w.a + distInfo.v1b.w.b
        let res = (this.graph.scrnH / 2 + v1b - this.selectedLensData.mu) / this.initScreenSize.h
        vVal = res * flag * 100
        let va = {}
        this.SET_VLENSSHIFT(vVal)
        va.max = res
        va.min = res
        this.SET_TEMVLENSSHIFT(va)
      }
      if (state && this.isUSTWall && this.USTLenshiftV) {
        vVal = this.USTLenshiftV
      }
      if (vVal) {
        let vData = (this.baseLTRay.y - this.baseLBRay.y) * vVal / 100
        LTRay.y += vData
        RTRay.y += vData
        RBRay.y += vData
        LBRay.y += vData
      }
      if (this.hLensShiftNow) {
        let hData = (this.baseRTRay.x - this.baseLTRay.x) * this.hLensShiftNow / 100
        LTRay.x += hData
        RTRay.x += hData
        RBRay.x += hData
        LBRay.x += hData
      }
      return { LTRay, RTRay, RBRay, LBRay }
    },
    setRayAngle (ray) {
      let xBaseVector = new THREE.Vector3(1, 0, 0)
      let vRotate = this.isUSTWall ? 0 : this.vAngle * Math.PI / 180
      let hRotate = this.isUSTWall ? 0 : this.hAngle * Math.PI / 180

      let yBaseVector = new THREE.Vector3(0, -1, 0)
      let rayDirect
      if (ray) {
        rayDirect = new THREE.Vector3(ray.x, ray.y, ray.z).normalize()
      }
      if ((this.vAngle && this.vAngleFlag)) {
        rayDirect.applyAxisAngle(xBaseVector, vRotate)
      }
      if ((this.hAngle && this.hAngleFlag)) {
        rayDirect.applyAxisAngle(yBaseVector, hRotate)
      }
      return rayDirect
    },
    setHelpLines (value, status) { // !status blackarea
      let topLineP = []
      let leftLineP = []
      let bottomLineP = []
      let rightLineP = []

      let LTRay = value.LTRay
      let RTRay = value.RTRay
      let RBRay = value.RBRay
      let LBRay = value.LBRay

      let divide = 50
      let lightCenter = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      // lightCenter.setZ(lightCenter.z + this.offsetVal)
      let helpLineGeo = new THREE.Geometry()
      let xBaseVector = new THREE.Vector3(1, 0, 0)
      let vRotate = this.vAngleFlag ? this.vAngle * Math.PI / 180 : 0
      let yBaseVector = new THREE.Vector3(0, -1, 0)
      let hRotate = this.hAngleFlag ? this.hAngle * Math.PI / 180 : 0

      let topLineDensity = (RTRay.x - LTRay.x) / divide
      for (let i = 0; i < divide; i++) {
        let topLineVector = new THREE.Vector3(LTRay.x + (topLineDensity * i), LTRay.y, LTRay.z)
        let topHelpLineDirection = topLineVector.normalize()
        topHelpLineDirection.applyAxisAngle(xBaseVector, vRotate)
        topHelpLineDirection.applyAxisAngle(yBaseVector, hRotate)
        let ray = new THREE.Raycaster(lightCenter, topHelpLineDirection)
        let point = this.getIntersectPoint(ray)
        this.setFlatPoint(point, status)
        topLineP.push(point.value)
        helpLineGeo.vertices.push(point.value)
      }

      let rightLineDensity = (RBRay.y - RTRay.y) / divide
      for (let i = 0; i < divide; i++) {
        let rightLineVector = new THREE.Vector3(RTRay.x, RTRay.y + (rightLineDensity * i), RTRay.z)
        let rightHelpLineDirection = rightLineVector.normalize()
        rightHelpLineDirection.applyAxisAngle(xBaseVector, vRotate)
        rightHelpLineDirection.applyAxisAngle(yBaseVector, hRotate)
        let ray = new THREE.Raycaster(lightCenter, rightHelpLineDirection)
        let point = this.getIntersectPoint(ray)
        this.setFlatPoint(point, status)
        rightLineP.push(point.value)
        helpLineGeo.vertices.push(point.value)
      }

      let bottomLineDensity = (LBRay.x - RBRay.x) / divide
      for (let i = 0; i < divide; i++) {
        let bottomLineVector = new THREE.Vector3(RBRay.x + (bottomLineDensity * i), RBRay.y, RBRay.z)
        let bottomHelpLineDirection = bottomLineVector.normalize()
        bottomHelpLineDirection.applyAxisAngle(xBaseVector, vRotate)
        bottomHelpLineDirection.applyAxisAngle(yBaseVector, hRotate)
        let ray = new THREE.Raycaster(lightCenter, bottomHelpLineDirection)
        let point = this.getIntersectPoint(ray)
        this.setFlatPoint(point, status)
        bottomLineP.push(point.value)
        helpLineGeo.vertices.push(point.value)
      }

      let leftLineDensity = (LTRay.y - LBRay.y) / divide
      for (let i = 0; i < divide; i++) {
        let leftLineVector = new THREE.Vector3(LBRay.x, LBRay.y + (leftLineDensity * i), LBRay.z)
        let leftHelpLineDirection = leftLineVector.normalize()
        leftHelpLineDirection.applyAxisAngle(xBaseVector, vRotate)
        leftHelpLineDirection.applyAxisAngle(yBaseVector, hRotate)
        let ray = new THREE.Raycaster(lightCenter, leftHelpLineDirection)
        let point = this.getIntersectPoint(ray)
        this.setFlatPoint(point, status)
        leftLineP.push(point.value)
        helpLineGeo.vertices.push(point.value)
      }
      helpLineGeo.vertices.push(topLineP[0])
      if (status) {
        let helpLineP = []
        helpLineP.push(this.edgePoints)
        helpLineP.push(topLineP)
        helpLineP.push(rightLineP)
        helpLineP.push(bottomLineP)
        helpLineP.push(leftLineP)

        this.helpLine = this.createHelpLine(helpLineGeo)
        this.helpLine.renderOrder = 80
        // this.helpLine.material.depthTest = false
        let drawData = this.setDrawData(helpLineP)
        this.dashDatas = helpLineP
        this.SET_DRAWDATA(drawData)
      } else {
        let blackHelpLineP = []
        blackHelpLineP.push(this.blackEdgePoints)
        blackHelpLineP.push(topLineP)
        blackHelpLineP.push(rightLineP)
        blackHelpLineP.push(bottomLineP)
        blackHelpLineP.push(leftLineP)

        // this.blackHelpLine = this.createblackHelpLine(helpLineGeo)
        // this.blackHelpLine.renderOrder = 2
        let blackDrawData = this.setDrawData(blackHelpLineP)
        this.SET_BLACKDRAWDATA(blackDrawData)
      }
    },
    setDashLines () {
      if (this.dashFlag) {
        let helpLineGeos = new THREE.Geometry()
        let dashDataStor = []
        for (let i = 0; i < this.dashDataRemain.length; i++) {
          let dashDataStorL = []
          for (let j = 0; j < this.dashDataRemain[i].length; j++) {
            if (i !== 0) {
              helpLineGeos.vertices.push(this.dashDataRemain[i][j])
            }
            dashDataStorL.push(this.dashDataRemain[i][j])
          }
          dashDataStor.push(dashDataStorL)
        }
        helpLineGeos.vertices.push(this.dashDataRemain[1][0])
        this.dashLine = this.createDashLine(helpLineGeos)
        this.dashLine.renderOrder = 80
        let dashDataStore = this.setDrawData(dashDataStor)
        this.SET_DASHDATA(dashDataStore)
      }
    },
    setFlatPoint (point, status) {
      if (point.position && status) {
        this.allPoints.push(point.value)
        switch (point.position) {
          case 'front':
            this.frontFlatP.push(point.value)
            break
          case 'right':
            this.rightFlatP.push(point.value)
            break
          case 'left':
            this.leftFlatP.push(point.value)
            break
          case 'top':
            this.topFlatP.push(point.value)
            break
          case 'bottom':
            this.bottomFlatP.push(point.value)
            break
          default:
            break
        }
      }
    },
    initFlatColor () {
      if (this.allPoints.length === 0) {
        return
      }
      let rLen = this.rightFlatP.length
      let lLen = this.leftFlatP.length
      let tLen = this.topFlatP.length
      let bLen = this.bottomFlatP.length
      let point = this.getRoomCubePoint()
      var frontShape = new THREE.Shape()
      frontShape.moveTo(this.allPoints[0].x, this.allPoints[0].y)
      for (let i = 1; i < this.allPoints.length; i++) {
        frontShape.lineTo(this.allPoints[i].x, this.allPoints[i].y)
      }
      var frontGeo = new THREE.ShapeGeometry(frontShape)
      var material = new THREE.MeshBasicMaterial({ color: 0xfbfcb5, opacity: 0.85, side: THREE.DoubleSide, transparent: true })
      this.frontMesh = new THREE.Mesh(frontGeo, material)
      this.frontMesh.position.setZ(point.b2.z + this.offsetVal + this.wallOffset)
      this.addToScene(this.frontMesh)
      if (this.isOutOfSpec) {
        return
      }
      // if (!this.offsetVal) {
      if (rLen || lLen) {
        var sideShape = new THREE.Shape()
        sideShape.moveTo(this.allPoints[0].y, this.allPoints[0].z)
        for (let i = 1; i < this.allPoints.length; i++) {
          sideShape.lineTo(this.allPoints[i].y, this.allPoints[i].z)
        }
        var sideGeo = new THREE.ShapeGeometry(sideShape)
        this.sideMesh = new THREE.Mesh(sideGeo, material)
        this.sideMesh.rotation.y = Math.PI / 2
        this.sideMesh.rotation.z = Math.PI / 2
        if (lLen) {
          this.sideMesh.position.setX(point.b1.x + this.wallOffset)
        } else {
          this.sideMesh.position.setX(point.b2.x - this.wallOffset)
        }
        this.addToScene(this.sideMesh)
      }

      if (tLen || bLen) {
        var topShape = new THREE.Shape()
        topShape.moveTo(this.allPoints[0].x, this.allPoints[0].z)
        for (let i = 1; i < this.allPoints.length; i++) {
          topShape.lineTo(this.allPoints[i].x, this.allPoints[i].z)
        }
        var topGeo = new THREE.ShapeGeometry(topShape)
        this.topMesh = new THREE.Mesh(topGeo, material)
        this.topMesh.rotation.x = Math.PI / 2
        if (tLen) {
          this.topMesh.position.setY(point.b1.y)
        } else {
          this.topMesh.position.setY(point.c1.y + this.wallOffset)
        }
        this.addToScene(this.topMesh)
      }
      // }
    },
    updateFlatColor () {
      this.scene.remove(this.frontMesh)
      this.scene.remove(this.sideMesh)
      this.scene.remove(this.topMesh)
      this.initFlatColor()
    },
    setDrawData (data) {
      var drawData = []
      for (var i = 0; i < data.length; i++) {
        drawData[i] = []
        for (var j = 0; j < data[i].length; j++) {
          drawData[i][j] = this.transTwoViewP(data[i][j])
        }
      }
      return drawData
    },
    /**
     * 将3d的坐标轴转化为2d的坐标轴
     */
    transTwoViewP (p) {
      var res = {}
      res.x = (p.x + this.houseInfo.roomW / 100 / 2) * 100
      res.y = (p.z + this.houseInfo.roomD / 100 / 2) * 100
      res.z = (-p.y + this.houseInfo.roomH / 100 / 2) * 100
      return res
    },
    getIntersectPoint (ray) {
      // let frontIntersects = ray.intersectObject(this.frontWallImg)
      // let frontIntersects = ray.intersectObject(this.curtainImg)
      let frontIntersects
      if (this.isSimple) {
        // 超出墙之后的点
        frontIntersects = this.isCurvedWallDisplay ? ray.intersectObject(this.cylinderGeo) : ray.intersectObject(this.frontBigWallImg)
      } else {
        // 不超出墙
        frontIntersects = this.isCurvedWallDisplay ? ray.intersectObject(this.cylinderGeo) : ray.intersectObject(this.curtainImg)
      }
      let lightCenter = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      if (frontIntersects.length > 0) {
        return { 'value': frontIntersects[0].point, 'position': 'front' }
      }
      let leftIntersects = ray.intersectObject(this.leftWallImg)
      if (leftIntersects.length > 0) {
        return { 'value': leftIntersects[0].point, 'position': 'left' }
      }
      let rightIntersects = ray.intersectObject(this.rightWallImg)
      if (rightIntersects.length > 0) {
        return { 'value': rightIntersects[0].point, 'position': 'right' }
      }
      let bottomIntersects = ray.intersectObject(this.floor)
      if (bottomIntersects.length > 0) {
        return { 'value': bottomIntersects[0].point, 'position': 'bottom' }
      }

      let topIntersects = ray.intersectObject(this.roof)
      if (topIntersects.length > 0) {
        return { 'value': topIntersects[0].point, 'position': 'top' }
      }
      return { 'value': lightCenter }
    },
    getBigWallIntersectPoint (ray) {
      let bigWallIntersects = ray.intersectObject(this.frontBigWallImg)
      if (bigWallIntersects.length > 0) {
        return bigWallIntersects[0].point
      }
    },
    createCenterLine (startP, endP) {
      let meterial = new THREE.LineDashedMaterial({ color: 0xff6666, dashSize: 1, gapSize: 1 })
      var geometry = new THREE.Geometry()
      geometry.vertices.push(startP, endP)
      this.centerLine = new THREE.Line(geometry, meterial)
      // this.addToScene(this.centerLine)
    },
    createEdgeLine (startP, endP) {
      let edgeLinesMtl = new THREE.LineBasicMaterial({ color: this.getMtlColor(this.$constant.rectLineColor), linewidth: 1 })
      let geometry = new THREE.Geometry()
      geometry.vertices.push(startP, endP)
      let line = new THREE.Line(geometry, edgeLinesMtl)
      this.addToScene(line)
      return line
    },
    createHelpLine (vertices) {
      let helpLinesMtl = new THREE.LineBasicMaterial({ color: this.getMtlColor(this.$constant.rectLineColor), linewidth: 3 })

      let helpLine = new THREE.Line(vertices, helpLinesMtl)
      this.addToScene(helpLine)
      return helpLine
    },
    createDashLine (vertices) {
      let helpLinesMtl = new THREE.LineDashedMaterial({ color: this.getMtlColor(this.$constant.dashRemainLineColor), dashSize: 300, gapSize: 5 })

      let dashLine = new THREE.Line(vertices, helpLinesMtl)
      this.addToScene(dashLine)
      return dashLine
    },
    createblackHelpLine (vertices) {
      let helpLinesMtl = new THREE.LineBasicMaterial({ color: 0x141313, linewidth: 1 })

      let helpLine = new THREE.Line(vertices, helpLinesMtl)
      this.addToScene(helpLine)
      return helpLine
    },
    createAvailableRangeLine (vertices) {
      let lineMtl = new THREE.LineBasicMaterial({ color: 0x141313, linewidth: 1 })

      let line = new THREE.Line(vertices, lineMtl)
      this.addToScene(line)
      return line
    },
    removeLines () {
      this.scene.remove(this.centerLine)
      this.scene.remove(this.leftTopLine)
      this.scene.remove(this.rightTopLine)
      this.scene.remove(this.rightBottomLine)
      this.scene.remove(this.leftBottomLine)
      this.scene.remove(this.helpLine)
      this.scene.remove(this.dashLine)
      this.scene.remove(this.blackHelpLine)
      this.scene.remove(this.availableLine)
    },
    removePJModel () {
      this.transformCtrl.detach()
      this.PJModelGroup.visible = false
      // this.scene.remove(this.PJModelGroup)
    },
    updateObjectMatrix () {
      this.floor.updateMatrix()
      this.floor.updateMatrixWorld()
      this.roof.updateMatrix()
      this.roof.updateMatrixWorld()
      this.curtainImg.updateMatrix()
      this.curtainImg.updateMatrixWorld()
      // this.frontWallImg.updateMatrix()
      // this.frontWallImg.updateMatrixWorld()
      this.frontBigWallImg.updateMatrix()
      this.frontBigWallImg.updateMatrixWorld()
      this.rightWallImg.updateMatrix()
      this.rightWallImg.updateMatrixWorld()
      this.leftWallImg.updateMatrix()
      this.leftWallImg.updateMatrixWorld()
    },

    setPjModelhAngle (value, initVal) {
      this.PJModelGroup.rotation.y = initVal.y - value * Math.PI / 180
    },
    setPjModelvAngle (value) {
      this.PJModelGroup.rotation.x = value * Math.PI / 180
    },
    updateRoomGeometry () {
      let point = this.getRoomCubePoint()
      this.updateWall()
      this.updateFloorAndRoof()
      this.setRoomGeometryPosition(point)
    },
    updateWall () {
      let scalex = this.houseInfo.roomW ? this.houseInfo.roomW / this.roomWInit : 0.1
      let scaley = this.houseInfo.roomH ? this.houseInfo.roomH / this.roomHInit : 0.1
      let scalez = this.houseInfo.roomD ? this.houseInfo.roomD / this.roomDInit : 0.1
      for (let i = 0; i < 2; i++) {
        this.frontWall.children[i].scale.x = scalex
        this.frontWall.children[i].scale.y = scaley

        this.rightWall.children[i].scale.x = scalez
        this.rightWall.children[i].scale.y = scaley
      }
      this.frontWallImg.scale.x = scalex
      this.frontWallImg.scale.y = scaley
      this.curtainImg.scale.x = scalex
      this.curtainImg.scale.y = scaley
      this.frontBigWallImg.scale.x = scalex
      this.frontBigWallImg.scale.y = scaley
      this.rightWallImg.scale.x = scalez
      this.rightWallImg.scale.y = scaley
      this.leftWallImg.scale.x = scalez
      this.leftWallImg.scale.y = scaley
    },
    updateFloorAndRoof () {
      let scalex = this.houseInfo.roomW ? this.houseInfo.roomW / this.roomWInit : 0.1
      let scalez = this.houseInfo.roomD ? this.houseInfo.roomD / this.roomDInit : 0.1
      this.floor.scale.x = scalex
      this.floor.scale.y = scalez
      this.roof.scale.x = scalex
      this.roof.scale.y = scalez
    },
    updateCurtainAndBigWallPosition () {
      let point = this.getRoomCubePoint()
      this.curtainImg.position.setZ(point.b2.z + this.offsetVal)
      this.frontBigWallImg.position.setZ(point.b2.z + this.offsetVal)
    },

    updatePJModelPosition () {
      let pointA = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      if (this.PJModelGroup.position) {
        this.PJModelGroup.position.set(pointA.x, pointA.y, pointA.z)
      }
    },
    updatePjModelType () {
      this.removePJModel()
      this.setPJModelAttibuteAndAddToScene()
    },
    getMtlColor (value) {
      let color = '0x' + value.slice(1)
      return parseInt(color)
    },
    getRoomCubePoint () {
      let roomCubePoint = {}
      let b1 = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getB1x(), this.$commonViewJs.getB1y(), this.$commonViewJs.getB1z()))
      let b2 = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getB2x(), this.$commonViewJs.getB2y(), this.$commonViewJs.getB2z()))
      // let b3 = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getB3x(), this.$commonViewJs.getB3y(), this.$commonViewJs.getB3z()))
      let threeD1 = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.get3D1x(), this.$commonViewJs.get3D1y(), this.$commonViewJs.get3D1z()))
      let threeD2 = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.get3D2x(), this.$commonViewJs.get3D2y(), this.$commonViewJs.get3D2z()))
      let threeD3 = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.get3D3x(), this.$commonViewJs.get3D3y(), this.$commonViewJs.get3D3z()))
      let c1 = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getC1x(), this.$commonViewJs.getC1y(), this.$commonViewJs.getC1z()))
      let c3 = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getC3x(), this.$commonViewJs.getC3y(), this.$commonViewJs.getC3z()))
      roomCubePoint.b1 = b1
      roomCubePoint.b2 = b2
      roomCubePoint.threeD1 = threeD1
      roomCubePoint.threeD2 = threeD2
      roomCubePoint.threeD3 = threeD3
      roomCubePoint.c1 = c1
      roomCubePoint.c3 = c3
      return roomCubePoint
    },
    onTransformMouseDown (event) {
      this.isDraggingPj = true
    },
    onTransformMouseUp () {
      if (this.isDraggingPj) {
        this.isDraggingPj = false
        this.updatePJModelPosition()
        this.OrbitControls.enableRotate = true
      }
    },
    reDrawLines () {
      this.createRay(this.aspectRatio, false)
      let lightCenter = this.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      this.scene.remove(this.leftTopLine)
      this.scene.remove(this.rightTopLine)
      this.scene.remove(this.rightBottomLine)
      this.scene.remove(this.leftBottomLine)
      this.leftTopLine = this.createEdgeLine(lightCenter, this.leftTopP)
      this.rightTopLine = this.createEdgeLine(lightCenter, this.rightTopP)
      this.rightBottomLine = this.createEdgeLine(lightCenter, this.rightBottomP)
      this.leftBottomLine = this.createEdgeLine(lightCenter, this.leftBottomP)
      let rayX = lightCenter.x - this.leftTopP.x
      let rayY = lightCenter.y - this.leftTopP.y
      let rayZ = lightCenter.z - this.leftTopP.z

      let valX = -1 / rayZ * rayX - this.baseLTRay.x
      let valY = -1 / rayZ * rayY - this.baseLTRay.y

      let lensshiftV = 100 * valY / (this.baseLTRay.y - this.baseLBRay.y)
      let lensshiftH = 100 * valX / (this.baseRTRay.x - this.baseLTRay.x)
      lensshiftV = Number(lensshiftV).toFixed(0)
      lensshiftH = Number(lensshiftH).toFixed(0)
      this.SET_VLENSSHIFT(Number(lensshiftV))
      this.SET_HLENSSHIFT(Number(lensshiftH))
      // this.SET_VLENSSHIFT(Number(lensshiftV).toFixed(1))
      // console.log(lensshiftV + this.vLensShift)
      // console.log(lensshiftH)
    },
    OnProjectorDrag (event) {
      let point = this.getRoomCubePoint()
      let wMax = Math.abs(point.b1.x)
      let hMax = Math.abs(point.b1.y)
      let dRangeByLens = this.$commonViewJs.getMinDisByLens()
      let dRangeByLensMax = this.transCoordToThreeDY(dRangeByLens.maxDis)
      let dRangeByLensMin = this.transCoordToThreeDY(dRangeByLens.minDis)
      let dMin = this.isOutOfSpec ? this.transCoordToThreeDY(this.offset + this.limitData) : dRangeByLensMin
      let dRangeByRoom = this.transCoordToThreeDY(this.$commonViewJs.getMaxDisByRoom())
      let dMax = this.isOutOfSpec ? Number.POSITIVE_INFINITY : Math.min(dRangeByLensMax, dRangeByRoom, point.c1.z)
      let Px = event.target.worldPosition.x
      let Py = event.target.worldPosition.y
      let Pz = event.target.worldPosition.z
      let xOutOfRange = false
      let yOutOfRange = false
      let zOutOfRange = false
      this.outOfRange = false

      if (Math.abs(Px) > wMax && this.transformCtrl.axis.indexOf('X') !== -1) {
        xOutOfRange = true
        Px > 0 ? Px = wMax : Px = -wMax
      }
      if (Math.abs(Py) > hMax && this.transformCtrl.axis.indexOf('Y') !== -1) {
        yOutOfRange = true
        Py > 0 ? Py = hMax : Py = -hMax
      }
      if ((Pz < dMin || Pz > dMax) && this.transformCtrl.axis.indexOf('Z') !== -1) {
        zOutOfRange = true
        Pz < dMin ? Pz = dMin : Pz = dMax
      }

      if (xOutOfRange || yOutOfRange || zOutOfRange) {
        this.outOfRange = true
        this.transformCtrl.dragging = false
      } else {
        this.outOfRange = false
        this.OrbitControls.enableRotate = false
        this.transformCtrl.dragging = true
      }

      let screenToLens = this.transCoordToZ(Pz) - this.offset
      this.PJX(this.transCoordToX(Px))
      this.PJY(screenToLens)
      this.PJZ(this.transCoordToY(Py))
      this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(screenToLens))
      let screen = this.$commonViewJs.getScreenXyFromDist(screenToLens)
      this.SCRNW(screen.calX)
      this.SCRNH(screen.calY)
      if (point.c1.z < Math.abs(Pz)) {
        this.SET_GRAPH_ROOMD(Math.abs(Pz) * 2 * 100)
      }
    },
    transCoordToThreeD (vector) {
      let x = (vector.x - this.houseInfo.roomW / 2) / this.ratio
      let y = (vector.y - this.houseInfo.roomD / 2) / this.ratio
      let z = (vector.z - this.houseInfo.roomH / 2) / this.ratio
      return new THREE.Vector3(x, -z, y)
    },
    transCoordToThreeDX (val) {
      return (val - this.houseInfo.roomW / 2) / this.ratio
    },
    transCoordToThreeDZ (val) {
      return -(val - this.houseInfo.roomH / 2) / this.ratio
    },
    transCoordToThreeDY (val) {
      return (val - this.houseInfo.roomD / 2) / this.ratio
    },
    transCoordToX (val) {
      return this.ratio * val + this.houseInfo.roomW / 2
    },
    transCoordToY (val) {
      return this.ratio * (-val) + this.houseInfo.roomH / 2
    },
    transCoordToZ (val) {
      return this.ratio * val + this.houseInfo.roomD / 2
    },
    animate () {
      window.requestAnimationFrame(this.animate.bind(this))
      this.renderer.render(this.scene, this.camera)
    },
    initData () {
      if (this.screen_size_checked) {
        var screenSizeData = (this.screenSize * 1).toFixed(2)
        this.checkScreenSize(screenSizeData)
      }
      if (this.throw_distance_checked) {
        let result = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
        this.checkScreenSize(result)
        let screenSi = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
        this.PJZ(this.houseInfo.roomH - (this.flToB + screenSi.calY / 2 - screenSi.calY * this.vLensShiftNow / 100))
        this.PJX(this.flToL + screenSi.calX / 2 - screenSi.calX * this.hLensShiftNow / 100)
      } else {
        let result = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
        this.checkScreenSize(result)
      }
    },
    getScreenSizeRange () {
      let distInfoVal = this.$commonJs.findCurrentDistInfo(this.selectedLensData)
      let maxSize = this.$commonViewJs.getScreenByFromDistWide(this.$commonViewJs.getMaxDisByRoom())
      let min = distInfoVal.screenSize.w.min
      let max = maxSize > distInfoVal.screenSize.w.max ? distInfoVal.screenSize.w.max : maxSize
      max = (max * 1).toFixed(2)
      return {
        max: max,
        min: min
      }
    },
    checkScreenSize (screenSize) {
      let { max, min } = this.getScreenSizeRange()
      screenSize = this.$commonJs.checkRange(screenSize, min, max)
      this.SET_SCREENSIZE(screenSize)
      let distance = this.$commonViewJs.calScreensizeToDistanceWide(screenSize)
      this.PJY(distance)

      var initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
      this.SET_INITSCREENSIZEW(initScreen.calX)
      this.SET_INITSCREENSIZEH(initScreen.calY)
      this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY))
      let screen = this.$commonViewJs.getScreenXyFromDist(this.graph.pjY)
      this.SCRNW(screen.calX)
      this.SCRNH(screen.calY)
    },
    createPJModels () {
      Promise.all([this.loadPJModels('EB-L600U'), this.loadPJModels('EB-700U'), this.loadPJModels('EB-L1500_1700')])
        .then((reArr) => {
          this.PJModelGroupType0 = reArr[0]
          this.PJModelGroupType1 = reArr[1]
          this.PJModelGroupType2 = reArr[2]
          this.setPJModelAttibuteAndAddToScene()
        })
    },
    loadPJModels (imgName) {
      let defaultUrl = this.publicPath + 'img/3d/'
      var onProgress = function (xhr) {
        if (xhr.lengthComputable) {
          // var percentComplete = xhr.loaded / xhr.total * 100
          // console.log(Math.round(percentComplete, 2) + '% downloaded')
        }
      }
      var onError = function (err) { throw err }
      return new Promise((resolve) => {
        return new MTLLoader()
          .setPath(defaultUrl)
          .load(imgName + '.mtl', (materials) => {
            materials.preload()
            return new OBJLoader()
              .setPath(defaultUrl)
              .setMaterials(materials)
              .load(imgName + '.obj', (object) => {
                object.traverse((child) => {
                  if (child instanceof THREE.Mesh) {
                    child.geometry.center()
                    child.geometry.computeBoundingSphere()
                  }
                })
                let boxHelper = new THREE.BoxHelper(object)
                let PJModelGroup = new THREE.Group()
                PJModelGroup.add(object)
                PJModelGroup.add(boxHelper)
                boxHelper.visible = false

                return resolve(PJModelGroup)
              })
          }, onProgress, onError)
      })
    }
  },
  computed: {
    ...mapState(['graph', 'houseInfo', 'pjImgType', 'vAngle', 'aspectRatio', 'selectedModelData', 'selectedLensData', 'vAngleFlag', 'hAngleFlag',
      'throwDistanceChecked', 'screenSizeChecked', 'vLensShiftNow', 'hLensShiftNow', 'initScreenSize', 'offset', 'dashFlag',
      'dashData', 'hAngle', 'dashDataRemain', 'position', 'limitData', 'vLensShiftInit', 'selectedModelData', 'screen4Point', 'screenSize',
      'flToB', 'flToL', 'isUSTWall', 'isOutOfSpec', 'isSimple']),
    throw_distance_checked: {
      get () {
        return this.isUSTWall ? false : this.throwDistanceChecked
      }
    },
    screen_size_checked: {
      get () {
        return this.isUSTWall ? false : this.screenSizeChecked
      }
    },
    pjX () {
      return this.graph.pjX
    },
    pjY () {
      return this.graph.pjY
    },
    pjZ () {
      return this.graph.pjZ
    },
    vLensShiftMax () {
      return this.graph.vLensShift.max
    },
    vLensShiftMin () {
      return this.graph.vLensShift.min
    },
    hLensShiftMax () {
      return this.graph.hLensShift.max
    },
    hLensShiftMin () {
      return this.graph.hLensShift.min
    },
    vhLensShiftMax () {
      return isNaN(this.graph.vhLensShift.max) ? 0 : this.graph.vhLensShift.max
    },
    vhLensShiftMin () {
      return isNaN(this.graph.vhLensShift.min) ? 0 : this.graph.vhLensShift.min
    },
    offsetVal () {
      return this.offset / 100
    },
    isCheckBoxDisable () {
      return this.screen_size_checked || this.throw_distance_checked
    },
    projectorImgType: {
      get () {
        if (this.selectedModelData.lensExchange && this.selectedLensData &&
        this.selectedLensData.id && this.selectedLensData.id.indexOf('LX') > -1) {
          return 2
        } else {
          return this.pjImgType
        }
      },
      set (val) {
        this.updatePjModelType()
      }
    }
  },
  watch: {
    graph: {
      handler (newVal, oldVal) {
        if (!this.isDraggingPj || this.outOfRange) {
          if (this.PJModelGroup) {
            this.updatePJModelPosition()
          }
        }
        this.setLines()
        // if (!this.screen_size_checked) {
        //   // 获取黑边的长宽
        //   var initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
        //   this.SET_INITSCREENSIZEW(initScreen.calX)
        //   this.SET_INITSCREENSIZEH(initScreen.calY)
        //   this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY))
        //   let screen = this.$commonViewJs.getScreenXyFromDist(this.graph.pjY)
        //   this.SCRNW(screen.calX)
        //   this.SCRNH(screen.calY)
        // }
      },
      deep: true
    },
    houseInfo: {
      handler (newValue, oldValue) {
        this.updateRoomGeometry()
        if (this.PJModelGroup) {
          this.updatePJModelPosition()
        }
        this.setLines()
      },
      deep: true
    },
    hAngle: {
      handler (newValue, oldValue) {
        let val = this.getPJModelInitRotation()
        this.setPjModelhAngle(newValue, val)
        this.setLines()
      }
    },
    hAngleFlag: {
      handler (newValue, oldValue) {
        if (this.dashFlag) {
          this.SET_DASHDATAREMAIN(this.dashDatas)
        }
        this.setLines()
        let val = this.getPJModelInitRotation()
        if (!newValue) {
          this.setPjModelhAngle(0, val)
        } else {
          this.setPjModelhAngle(this.hAngle, val)
        }
      }
    },
    vAngle: {
      handler (newValue, oldValue) {
        this.setPjModelvAngle(newValue)
        this.setLines()
      }
    },
    vAngleFlag: {
      handler (newValue, oldValue) {
        if (this.dashFlag) {
          this.SET_DASHDATAREMAIN(this.dashDatas)
        }
        this.setLines()
        if (!newValue) {
          this.setPjModelvAngle(0)
        } else {
          this.setPjModelvAngle(this.vAngle)
        }
      }
    },
    USTLenshiftV: {
      handler () {
        this.setLines()
      }
    },
    vLensShiftNow: {
      handler (newValue, oldValue) {
        if (!this.throw_distance_checked) {
          this.setLines()
        }
      }
    },
    hLensShiftNow: {
      handler (newValue, oldValue) {
        if (!this.throw_distance_checked) {
          this.setLines()
        }
      }
    },
    offsetVal: {
      handler (newValue, oldValue) {
        this.updatePJModelPosition()
        this.updateCurtainAndBigWallPosition()
        this.setLines()
      }
    },
    position (val) {
      if (val === 2) {
        let value = this.houseInfo.roomH - 180 > 0 ? this.houseInfo.roomH - 180 : 0
        if (this.graph.pjZ < value) {
          this.PJZ(value)
        }
      }
      this.setPJModelRotation(val)
    },
    selectedLensData (newValue, oldValue) {
      if (this.selectedModelData.lensExchange && this.selectedLensData &&
       this.selectedLensData.id && this.selectedLensData.id.indexOf('LX') > -1) {
        this.projectorImgType = 2
      } else {
        this.projectorImgType = this.pjImgType
      }
    }
  },
  created () {
    this.createPJModels()
  },
  mounted () {
    this.initData()
    this.init()
    this.animate()
  }
}
</script>

<style scoped>

.three-d-view {
  /* height: 345px; */
  width: 100%;
  height: 100%;
}

.threed-img {
  background: url('../../assets/parts/icon/icon_3d.png') no-repeat center;
  width: 30px;
  height: 30px;
  float: left;
}
.threedcontainer {
  width: 100%;
  height: calc(100%);
  text-align: center;
  position: relative;
}
</style>
